/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

import { logError } from "app/client/models/errors";
import { Level, TelemetryContracts, TelemetryEvent, TelemetryMetadataByLevel } from "app/common/Telemetry";
import { fetchFromHome, getGristConfig, pageHasHome } from "app/common/urlUtils";

export function logTelemetryEvent(event: TelemetryEvent, metadata?: TelemetryMetadataByLevel) {
  if (!pageHasHome()) { return; }

  const { telemetry } = getGristConfig();
  if (!telemetry) { return; }

  const { telemetryLevel } = telemetry;
  if (Level[telemetryLevel] < TelemetryContracts[event].minimumTelemetryLevel) { return; }

  fetchFromHome("/api/telemetry", {
    method: "POST",
    body: JSON.stringify({
      event,
      metadata,
    }),
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  }).catch((e: Error) => {
    console.warn(`Failed to log telemetry event ${event}`, e);
    logError(e);
  });
}
